// Use import.meta.env - Vite's way to access environment variables
// Jest mock is configured to handle import.meta.env
export const FAQ_BASE_URL =
  import.meta.env.VITE_FAQ_BASE_URL || 'https://resources.samsunghrm.com';

export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
};

export const DEFAULT_REFETCH_INTERVAl = 6000;
export const REMOTE_REFETCH_INTERVAL = 1000;
export const REGULAR = 'regular';
export const FORCED = 'forced';
export const USIGN_PINCODE = 'usingPincode';

export const resourcesVersion = '250616';

export const svcSymptomCodeDef = {
  airconditioner: 'AC-100',
  fridge: 'RN-100',
};

export const monitoringDataDisplaytype = {
  refrigerator: {
    waterFilter: {
      DISABLE: '필터 정상',
      ENABLE: '필터 교체',
    },
    // guideTextTmpl:
    //   '<li class="list-item">- ' +
    //   'MONITORING_CONTROL_REFRIGERATOR_TEXT_GUIDE_LIST_1') ),+
    //   '</li>',
    nonFreezingModes: {
      FCONVERT_CHILL: 'MONITORING_CONTROL_REFRIGERATOR_FCONVERT_CHILL',
      FCONVERT_COOL: 'MONITORING_CONTROL_REFRIGERATOR_FCONVERT_COOL',
      FCONVERT_COLD: 'MONITORING_CONTROL_REFRIGERATOR_FCONVERT_COLD',
      FCONVERT_SOFT_FREEZING_22K:
        'MONITORING_CONTROL_REFRIGERATOR_FCONVERT_SOFT_FREEZING_22K',
      FCONVERT_FRIDGE: 'MONITORING_CONTROL_REFRIGERATOR_FCONVERT_FRIDGE',
      FCONVERT_KIMCHI: 'MONITORING_CONTROL_REFRIGERATOR_FCONVERT_KIMCHI',
      FCONVERT_KIMCHI_COLD:
        'MONITORING_CONTROL_REFRIGERATOR_FCONVERT_KIMCHI_COLD',
      FCONVERT_KIMCHI_NORMAL:
        'MONITORING_CONTROL_REFRIGERATOR_FCONVERT_KIMCHI_NORMAL',
      FCONVERT_KIMCHI_WARM:
        'MONITORING_CONTROL_REFRIGERATOR_FCONVERT_KIMCHI_WARM',
      FCONVERT_OFF: 'MONITORING_CONTROL_REFRIGERATOR_FCONVERT_OFF',
      FCONVERT_SOFT_FREEZING:
        'MONITORING_CONTROL_REFRIGERATOR_FCONVERT_SOFT_FREEZING',
    },
    cvRoomModes: {
      CV_CHEESE: 'MONITORING_CONTROL_REFRIGERATOR_CV_CHEESE',
      CV_DACOR_CHILL_MEAT:
        'MONITORING_CONTROL_REFRIGERATOR_CV_DACOR_CHILL_MEAT',
      CV_DACOR_COOL: 'MONITORING_CONTROL_REFRIGERATOR_CV_DACOR_COOL',
      CV_DACOR_FREEZER: 'MONITORING_CONTROL_REFRIGERATOR_CV_DACOR_FREEZERL',
      CV_DACOR_FREEZERL: 'MONITORING_CONTROL_REFRIGERATOR_CV_DACOR_FREEZERL',
      CV_DACOR_SOFT_FREEZING:
        'MONITORING_CONTROL_REFRIGERATOR_CV_DACOR_SOFT_FREEZING',
      CV_FAST_COOLING: 'MONITORING_CONTROL_REFRIGERATOR_CV_FAST_COOLING',
      CV_FDR_BEVERAGE: 'MONITORING_CONTROL_REFRIGERATOR_CV_FDR_BEVERAGE',
      CV_FDR_COLD_DRINKS: 'MONITORING_CONTROL_REFRIGERATOR_CV_FDR_COLD_DRINKS',
      CV_FDR_DELI: 'MONITORING_CONTROL_REFRIGERATOR_CV_FDR_DELI',
      CV_FDR_DELI_SNACKS: 'MONITORING_CONTROL_REFRIGERATOR_CV_FDR_DELI_SNACKS',
      CV_FDR_DELI_SNACKS_DACOR:
        'MONITORING_CONTROL_REFRIGERATOR_CV_FDR_DELI_SNACKS_DACOR',
      CV_FDR_MEAT: 'MONITORING_CONTROL_REFRIGERATOR_CV_FDR_MEAT',
      CV_FDR_MEAT_FISH: 'MONITORING_CONTROL_REFRIGERATOR_CV_FDR_MEAT_FISH',
      CV_FDR_MEAT_FISH_DACOR:
        'MONITORING_CONTROL_REFRIGERATOR_CV_FDR_MEAT_FISH_DACOR',
      CV_FDR_WINE: 'MONITORING_CONTROL_REFRIGERATOR_CV_FDR_WINE',
      CV_FDR_WINE_PARTY_DISHES:
        'MONITORING_CONTROL_REFRIGERATOR_CV_FDR_WINE_PARTY_DISHES',
      CV_FDR_WINE_PARTY_DISHES_DACOR:
        'MONITORING_CONTROL_REFRIGERATOR_CV_FDR_WINE_PARTY_DISHES_DACOR',
      CV_FDR_SOFT_FREEZER:
        'MONITORING_CONTROL_REFRIGERATOR_CV_FDR_SOFT_FREEZER',
      CV_FHUB_BEER: 'MONITORING_CONTROL_REFRIGERATOR_CV_FHUB_BEER',
      CV_FHUB_BEER_WINE: 'MONITORING_CONTROL_REFRIGERATOR_CV_FHUB_BEER_WINE',
      CV_FHUB_FREEZER: 'MONITORING_CONTROL_REFRIGERATOR_CV_FHUB_FREEZER',
      CV_FHUB_FRIDGE: 'MONITORING_CONTROL_REFRIGERATOR_CV_FHUB_FRIDGE',
      CV_FHUB_KIMCHI_COLD:
        'MONITORING_CONTROL_REFRIGERATOR_CV_FHUB_KIMCHI_COLD',
      CV_FHUB_KIMCHI_NORMAL:
        'MONITORING_CONTROL_REFRIGERATOR_CV_FHUB_KIMCHI_NORMAL',
      CV_FHUB_KIMCHI_WARM:
        'MONITORING_CONTROL_REFRIGERATOR_CV_FHUB_KIMCHI_WARM',
      CV_FHUB_MEAT_FISH: 'MONITORING_CONTROL_REFRIGERATOR_CV_FHUB_MEAT_FISH',
      CV_FHUB_SOFT_FREEZER:
        'MONITORING_CONTROL_REFRIGERATOR_CV_FHUB_SOFT_FREEZER',
      CV_FHUB_VEGETABLE_CHEESE:
        'MONITORING_CONTROL_REFRIGERATOR_CV_FHUB_VEGETABLE_CHEESE',
      CV_FREEZER: 'MONITORING_CONTROL_REFRIGERATOR_CV_FREEZER',
      CV_FRIDGE: 'MONITORING_CONTROL_REFRIGERATOR_CV_FRIDGE',
      CV_MINUS_1_ZONE: 'MONITORING_CONTROL_REFRIGERATOR_CV_MINUS_1_ZONE',
      CV_OFF: 'MONITORING_CONTROL_REFRIGERATOR_CV_OFF',
      CV_SBS_BEVERAGE: 'MONITORING_CONTROL_REFRIGERATOR_CV_SBS_BEVERAGE',
      CV_SBS_DEFROST_10HR:
        'MONITORING_CONTROL_REFRIGERATOR_CV_SBS_DEFROST_10HR',
      CV_SBS_DEFROST_5HR: 'MONITORING_CONTROL_REFRIGERATOR_CV_SBS_DEFROST_5HR',
      CV_SBS_FRIDGE: 'MONITORING_CONTROL_REFRIGERATOR_CV_SBS_FRIDGE',
      CV_SBS_FRIDGE_18K: 'MONITORING_CONTROL_REFRIGERATOR_CV_SBS_FRIDGE_18K',
      CV_SBS_FRUIT_VEGETABLE:
        'MONITORING_CONTROL_REFRIGERATOR_CV_SBS_FRUIT_VEGETABLE',
      CV_SBS_MEAT_FISH: 'MONITORING_CONTROL_REFRIGERATOR_CV_SBS_MEAT_FISH',
      CV_SBS_RAPID_FRIDGE:
        'MONITORING_CONTROL_REFRIGERATOR_CV_SBS_RAPID_FRIDGE',
      CV_SOFT_FREEZER: 'MONITORING_CONTROL_REFRIGERATOR_CV_SOFT_FREEZER',
      CV_SSEC_CHILL: 'MONITORING_CONTROL_REFRIGERATOR_CV_SSEC_CHILL',
      CV_SSEC_COOL: 'MONITORING_CONTROL_REFRIGERATOR_CV_SSEC_COOL',
      CV_SSEC_FREEZER: 'MONITORING_CONTROL_REFRIGERATOR_CV_SSEC_FREEZER',
      CV_SSEC_SOFT_FREEZER:
        'MONITORING_CONTROL_REFRIGERATOR_CV_SSEC_SOFT_FREEZER',
      CV_TMF_FAST_COOLING:
        'MONITORING_CONTROL_REFRIGERATOR_CV_TMF_FAST_COOLING',
      CV_TMF_FREEZER: 'MONITORING_CONTROL_REFRIGERATOR_CV_TMF_FREEZER',
      CV_TMF_FRIDGE: 'MONITORING_CONTROL_REFRIGERATOR_CV_TMF_FRIDGE',
      CV_TMF_KIMCHI_NORMAL:
        'MONITORING_CONTROL_REFRIGERATOR_CV_TMF_KIMCHI_NORMAL',
      CV_TMF_KIMCHI_STRONGCOOL:
        'MONITORING_CONTROL_REFRIGERATOR_CV_TMF_KIMCHI_STRONGCOOL',
      CV_TMF_KIMCHI_WEAKCOOL:
        'MONITORING_CONTROL_REFRIGERATOR_CV_TMF_KIMCHI_WEAKCOOL',
      CV_TMF_MINUS_1_ZONE:
        'MONITORING_CONTROL_REFRIGERATOR_CV_TMF_MINUS_1_ZONE',
      CV_TMF_OFF: 'MONITORING_CONTROL_REFRIGERATOR_CV_TMF_OFF',
      CV_TMF_SOFT_FREEZER:
        'MONITORING_CONTROL_REFRIGERATOR_CV_TMF_SOFT_FREEZER',
      CV_TTYPE_BEER_WHITEWINE:
        'MONITORING_CONTROL_REFRIGERATOR_CV_TTYPE_BEER_WHITEWINE',
      CV_TTYPE_RF9000A_BEER_WHITEWINE:
        'MONITORING_CONTROL_REFRIGERATOR_CV_TTYPE_BEER_WHITEWINE',
      CV_TTYPE_CHILL: 'MONITORING_CONTROL_REFRIGERATOR_CV_TTYPE_CHILL',
      CV_TTYPE_COOL: 'MONITORING_CONTROL_REFRIGERATOR_CV_TTYPE_COOL',
      CV_TTYPE_COOL_18K: 'MONITORING_CONTROL_REFRIGERATOR_CV_TTYPE_COOL_18K',
      CV_TTYPE_FERMENT: 'MONITORING_CONTROL_REFRIGERATOR_CV_TTYPE_FERMENT',
      CV_TTYPE_FREEZER: 'MONITORING_CONTROL_REFRIGERATOR_CV_TTYPE_FREEZER',
      CV_TTYPE_FREEZER_18K:
        'MONITORING_CONTROL_REFRIGERATOR_CV_TTYPE_FREEZER_18K',
      CV_TTYPE_KIMCHINORMAL:
        'MONITORING_CONTROL_REFRIGERATOR_CV_TTYPE_KIMCHINORMAL',
      CV_TTYPE_KIMCHISTRONG:
        'MONITORING_CONTROL_REFRIGERATOR_CV_TTYPE_KIMCHISTRONG',
      CV_TTYPE_KIMCHIWEAK:
        'MONITORING_CONTROL_REFRIGERATOR_CV_TTYPE_KIMCHIWEAK',
      CV_TTYPE_KIMCHI_COLD:
        'MONITORING_CONTROL_REFRIGERATOR_CV_TTYPE_KIMCHI_COLD',
      CV_TTYPE_KIMCHI_COLD_18K:
        'MONITORING_CONTROL_REFRIGERATOR_CV_TTYPE_KIMCHI_COLD_18K',
      CV_TTYPE_KIMCHI_NORMAL:
        'MONITORING_CONTROL_REFRIGERATOR_CV_TTYPE_KIMCHI_NORMAL',
      CV_TTYPE_KIMCHI_NORMAL_18K:
        'MONITORING_CONTROL_REFRIGERATOR_CV_TTYPE_KIMCHI_NORMAL_18K',
      CV_TTYPE_KIMCHI_WARM:
        'MONITORING_CONTROL_REFRIGERATOR_CV_TTYPE_KIMCHI_WARM',
      CV_TTYPE_KIMCHI_WARM_18K:
        'MONITORING_CONTROL_REFRIGERATOR_CV_TTYPE_KIMCHI_WARM_18K',
      CV_TTYPE_MEAT_FISH: 'MONITORING_CONTROL_REFRIGERATOR_CV_TTYPE_MEAT_FISH',
      CV_TTYPE_RF9000A_BEVERAGE:
        'MONITORING_CONTROL_REFRIGERATOR_CV_TTYPE_RF9000A_BEVERAGE',
      CV_TTYPE_RF9000A_FREEZE:
        'MONITORING_CONTROL_REFRIGERATOR_CV_TTYPE_RF9000A_FREEZE',
      CV_TTYPE_RF9000A_FRUIT_VEGGIES:
        'MONITORING_CONTROL_REFRIGERATOR_CV_TTYPE_RF9000A_FRUIT_VEGGIES',
      CV_TTYPE_RF9000A_MEAT_FISH:
        'MONITORING_CONTROL_REFRIGERATOR_CV_TTYPE_RF9000A_MEAT_FISH',
      CV_TTYPE_RF9000A_SOFTFREEZE:
        'MONITORING_CONTROL_REFRIGERATOR_CV_TTYPE_RF9000A_SOFTFREEZE',
      CV_TTYPE_SOFT_FREEZER:
        'MONITORING_CONTROL_REFRIGERATOR_CV_TTYPE_SOFT_FREEZER',
      CV_TTYPE_SOFT_FREEZER_18K:
        'MONITORING_CONTROL_REFRIGERATOR_CV_TTYPE_SOFT_FREEZER_18K',
      CV_VEGETABLE: 'MONITORING_CONTROL_REFRIGERATOR_CV_VEGETABLE',
      NEWMODE_CVROOM_2A: 'MONITORING_CONTROL_REFRIGERATOR_NEWMODE_CVROOM_2A',
      CV_TMF_LAMBFREEZER: 'MONITORING_CONTROL_REFRIGERATOR_CV_TMF_LAMBFREEZER',
      CV_TTYPE_TEA_GRAIN: 'MONITORING_CONTROL_REFRIGERATOR_CV_TTYPE_TEA_GRAIN',
    },
    pantryModes: {
      PANTRY_FDR_CHEESE: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_FDR_CHEESE',
      PANTRY_FDR_CHILLED: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_FDR_CHILLED',
      PANTRY_FDR_CHILL_MEAT:
        'MONITORING_CONTROL_REFRIGERATOR_PANTRY_FDR_CHILL_MEAT',
      PANTRY_FDR_COLD_DRINKS:
        'MONITORING_CONTROL_REFRIGERATOR_PANTRY_FDR_COLD_DRINKS',
      PANTRY_FDR_DELI: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_FDR_DELI',
      PANTRY_FDR_DRINKS: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_FDR_DRINKS',
      PANTRY_FDR_FRESH: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_FDR_FRESH',
      PANTRY_FDR_MEAT_FISH:
        'MONITORING_CONTROL_REFRIGERATOR_PANTRY_FDR_MEAT_FISH',
      PANTRY_FDR_WINE: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_FDR_WINE',
      PANTRY_TTYPE_CEREAL:
        'MONITORING_CONTROL_REFRIGERATOR_PANTRY_TTYPE_CEREAL',
      PANTRY_TTYPE_FRIDGE:
        'MONITORING_CONTROL_REFRIGERATOR_PANTRY_TTYPE_FRIDGE',
      PANTRY_TTYPE_FRUIT: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_TTYPE_FRUIT',
      PANTRY_TTYPE_BEVERAGE:
        'MONITORING_CONTROL_REFRIGERATOR_PANTRY_TTYPE_BEVERAGE',
      PANTRY_TTYPE_GRAINS:
        'MONITORING_CONTROL_REFRIGERATOR_PANTRY_TTYPE_GRAINS',
      PANTRY_TTYPE_MEATFISH:
        'MONITORING_CONTROL_REFRIGERATOR_PANTRY_TTYPE_MEATFISH',
      PANTRY_TTYPE_MEAT_FISH:
        'MONITORING_CONTROL_REFRIGERATOR_PANTRY_TTYPE_MEAT_FISH',
      PANTRY_TTYPE_REDWINE:
        'MONITORING_CONTROL_REFRIGERATOR_PANTRY_TTYPE_REDWINE',
      PANTRY_TTYPE_RF9000A_FRIDGE:
        'MONITORING_CONTROL_REFRIGERATOR_PANTRY_TTYPE_RF9000A_FRIDGE',
      PANTRY_TTYPE_TROPICAL:
        'MONITORING_CONTROL_REFRIGERATOR_PANTRY_TTYPE_TROPICAL',
      PANTRY_TTYPE_WHITEWINE:
        'MONITORING_CONTROL_REFRIGERATOR_PANTRY_TTYPE_WHITEWINE',
      PANTRY_KIMCHI_MEAT_FISH:
        'MONITORING_CONTROL_REFRIGERATOR_PANTRY_KIMCHI_MEAT_FISH',
      PANTRY_KIMCHI_CHILLED:
        'MONITORING_CONTROL_REFRIGERATOR_PANTRY_KIMCHI_CHILLED',
      PANTRY_KIMCHI_SOFT_FREEZER:
        'MONITORING_CONTROL_REFRIGERATOR_PANTRY_KIMCHI_SOFT_FREEZER',
      FDR_CHEESE: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_FDR_CHEESE',
      FDR_CHILLED: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_FDR_CHILLED',
      FDR_CHILL_MEAT: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_FDR_CHILL_MEAT',
      FDR_COLD_DRINKS: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_FDR_COLD_DRINKS',
      FDR_DELI: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_FDR_DELI',
      FDR_DRINKS: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_FDR_DRINKS',
      FDR_FRESH: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_FDR_FRESH',
      FDR_MEAT_FISH: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_FDR_MEAT_FISH',
      FDR_WINE: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_FDR_WINE',
      TTYPE_CEREAL: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_TTYPE_CEREAL',
      TTYPE_FRIDGE: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_TTYPE_FRIDGE',
      TTYPE_FRUIT: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_TTYPE_FRUIT',
      TTYPE_BEVERAGE: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_TTYPE_BEVERAGE',
      TTYPE_GRAINS: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_TTYPE_GRAINS',
      TTYPE_MEATFISH: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_TTYPE_MEATFISH',
      TTYPE_MEAT_FISH: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_TTYPE_MEAT_FISH',
      TTYPE_REDWINE: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_TTYPE_REDWINE',
      TTYPE_RF9000A_FRIDGE:
        'MONITORING_CONTROL_REFRIGERATOR_PANTRY_TTYPE_RF9000A_FRIDGE',
      TTYPE_TROPICAL: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_TTYPE_TROPICAL',
      TTYPE_WHITEWINE: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_TTYPE_WHITEWINE',
      TTYPE_MEAT_RIPE: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_TTYPE_MEAT_RIPE',
      KIMCHI_MEAT_FISH:
        'MONITORING_CONTROL_REFRIGERATOR_PANTRY_KIMCHI_MEAT_FISH',
      KIMCHI_CHILLED: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_KIMCHI_CHILLED',
      KIMCHI_SOFT_FREEZER:
        'MONITORING_CONTROL_REFRIGERATOR_PANTRY_KIMCHI_SOFT_FREEZER',
    },
    subIceStatus: {
      ID2_ICESTATUS_STOP: 'MONITORING_CONTROL_REFRIGERATOR_ICESTATUS_STOP',
      ID2_ICESTATUS_RUN: 'MONITORING_CONTROL_REFRIGERATOR_ICESTATUS_RUN',
    },
    subIceStatusName: {
      ID2_ICENAME_FREEZER: 'MONITORING_CONTROL_REFRIGERATOR_ICE_STATUS_FREEZER',
      ID2_ICENAME_TRANS: 'MONITORING_CONTROL_REFRIGERATOR_ICE_STATUS_TRANS',
      ID2_ICENAME_FRIDGE: 'MONITORING_CONTROL_REFRIGERATOR_ICE_STATUS_FRIDGE',
      ID2_ICENAME_COCKTAIL_ICE:
        'MONITORING_CONTROL_REFRIGERATOR_ICE_STATUS_ICE',
    },
    subIceStatusNameControl: {
      ID2_ICENAME_FREEZER: 'MONITORING_CONTROL_REFRIGERATOR_ICE_MAKER_FREEZER',
      ID2_ICENAME_TRANS: 'MONITORING_CONTROL_REFRIGERATOR_ICE_MAKER_TRANS',
      ID2_ICENAME_FRIDGE: 'MONITORING_CONTROL_REFRIGERATOR_ICE_MAKER_FRIDGE',
      ID2_ICENAME_COCKTAIL_ICE: 'MONITORING_CONTROL_REFRIGERATOR_ICE_MAKER_ICE',
    },
    pantryTitles: {
      PANTRY_NAME_ROOM: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_NAME_ROOM',
      PANTRY_NAME_CHEF: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_NAME_CHEF',
      PANTRY_NAME_FRESHZONE:
        'MONITORING_CONTROL_REFRIGERATOR_PANTRY_NAME_FRESHZONE',
      PANTRY_NAME_KIMCHI: 'MONITORING_CONTROL_REFRIGERATOR_PANTRY_NAME_KIMCHI',
    },
  },
};

// export const SESSION_KEYS = {
//   USER_ID: 'userId',
//   USER_ROLE: 'userRole',
//   USER_NAME: 'userName',
//   USER_GROUP_ID: 'userGroupId',
//   USER_PRIORITY: 'userPriority',
//   AUTH_TOKEN: 'authToken'
// };

// export const DEFAULT_TOKEN_EXPIRED = 12092; // as per legacy code
// export const API_TIMEOUT = 30000;

// --------------------------------------------------------------------------------

// Application constants file
// This file contains all constant values used throughout the application

export const PLATFORM = {
  MOBILE: 'mobile',
  WEBPAGE: 'webpage',
};

// HTTP Methods
export const HTTP_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
  HEAD: 'HEAD',
  OPTIONS: 'OPTIONS',
};

// Content Types
export const CONTENT_TYPES = {
  JSON: 'application/json',
  FORM_DATA: 'multipart/form-data',
  URL_ENCODED: 'application/x-www-form-urlencoded',
  TEXT: 'text/plain',
  HTML: 'text/html',
};

// Response Status Messages
export const RESPONSE_MESSAGES = {
  SUCCESS: 'Request successful',
  CREATED: 'Resource created successfully',
  UPDATED: 'Resource updated successfully',
  DELETED: 'Resource deleted successfully',
  NOT_FOUND: 'Resource not found',
  UNAUTHORIZED: 'Unauthorized access',
  FORBIDDEN: 'Access forbidden',
  SERVER_ERROR: 'Internal server error',
  NETWORK_ERROR: 'Network error occurred',
  TIMEOUT_ERROR: 'Request timeout',
  VALIDATION_ERROR: 'Validation failed',
};

// Loading States
export const LOADING_STATES = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

// Pagination
export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_PAGE_SIZE: 10,
  MAX_PAGE_SIZE: 100,
};

// Time Constants (in milliseconds)
export const TIME = {
  SECOND: 1000,
  MINUTE: 60 * 1000,
  HOUR: 60 * 60 * 1000,
  DAY: 24 * 60 * 60 * 1000,
  WEEK: 7 * 24 * 60 * 60 * 1000,
  MONTH: 30 * 24 * 60 * 60 * 1000,
};

// File Upload Limits
export const FILE_LIMITS = {
  MAX_SIZE_MB: 5,
  MAX_SIZE_BYTES: 5 * 1024 * 1024,
  ALLOWED_TYPES: [
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/webp',
    'application/pdf',
  ],
};

// Validation Patterns
export const VALIDATION_PATTERNS = {
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  PHONE: /^[+]?[\d\s-()]+$/,
  PASSWORD_MIN_LENGTH: 8,
  PASSWORD_MAX_LENGTH: 128,
  NAME_MIN_LENGTH: 2,
  NAME_MAX_LENGTH: 100,
};

// UI Breakpoints
export const BREAKPOINTS = {
  XS: '480px',
  SM: '640px',
  MD: '768px',
  LG: '1024px',
  XL: '1280px',
  '2XL': '1536px',
};

// Animation Durations
export const ANIMATIONS = {
  FAST: 150,
  NORMAL: 300,
  SLOW: 500,
};

// Z-Index Values
export const Z_INDEX = {
  BASE: 0,
  DROPDOWN: 1000,
  STICKY: 1020,
  MODAL: 1040,
  TOOLTIP: 1050,
  NOTIFICATION: 1060,
};

// Diagnosis Types
export const DIAGNOSIS_TYPES = {
  REMOTE: 'remote',
  HISTORY: 'history',
};

// User Roles
export const USER_ROLES = {
  ADMIN: 'admin',
  DOCTOR: 'doctor',
  PATIENT: 'patient',
  VIEWER: 'viewer',
};

// Session Storage Keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  USER_PREFERENCES: 'user_preferences',
  THEME: 'theme',
  LANGUAGE: 'language',
};

// API Response Keys
export const API_KEYS = {
  DATA: 'data',
  MESSAGE: 'message',
  SUCCESS: 'success',
  ERROR: 'error',
  TOKEN: 'token',
  USER: 'user',
  PAGINATION: 'pagination',
  META: 'meta',
};

// Date Formats
export const DATE_FORMATS = {
  API: 'YYYY-MM-DD',
  DISPLAY: 'DD MMM YYYY',
  DATETIME: 'DD MMM YYYY, HH:mm',
  ISO: 'YYYY-MM-DDTHH:mm:ss',
};

// Regular Expressions
export const REGEX = {
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  PHONE: /^[+]?[\d\s-()]+$/,
  PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@$!%*?&]{8,}$/,
  URL: /^https?:\/\/(?:www\.)?[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9](?:\.[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])*(?:\/.*)?$/,
};

// Error Types
export const ERROR_TYPES = {
  NETWORK: 'NETWORK_ERROR',
  VALIDATION: 'VALIDATION_ERROR',
  AUTHENTICATION: 'AUTHENTICATION_ERROR',
  AUTHORIZATION: 'AUTHORIZATION_ERROR',
  NOT_FOUND: 'NOT_FOUND',
  SERVER: 'SERVER_ERROR',
  TIMEOUT: 'TIMEOUT_ERROR',
  Unknown: 'UNKNOWN_ERROR',
};

export const CONSTANTS = {
  HTTP_METHODS,
  CONTENT_TYPES,
  RESPONSE_MESSAGES,
  LOADING_STATES,
  PAGINATION,
  TIME,
  FILE_LIMITS,
  VALIDATION_PATTERNS,
  BREAKPOINTS,
  ANIMATIONS,
  Z_INDEX,
  PLATFORM,
  DIAGNOSIS_TYPES,
  USER_ROLES,
  STORAGE_KEYS,
  API_KEYS,
  DATE_FORMATS,
  REGEX,
  ERROR_TYPES,
};

export default CONSTANTS;
